const treeDataToNavigation = tree => tree.reduce(([navigation, ids], node) => {
  const { children, expanded, navigationItem } = node;

  let newIds = ids;

  if (expanded) {
    newIds = [...ids, navigationItem.id];
  }

  let navigationItems;
  let childIds = [];

  if (children) {
    [navigationItems, childIds] = treeDataToNavigation(children);
  }

  return [
    [...navigation, { ...navigationItem, navigationItems }],
    [...newIds, ...childIds],
  ];
}, [[], []]);

export default treeDataToNavigation;
